export const A4_WIDTH = 816;
export const A4_HEIGHT = 1123;
export const PADDING = 40;

export const PAGE_HEIGHT_MM = 297;
export const PAGE_WIDTH_MM = 210;
export const PADDING_X_MM = 25.4;
export const PADDING_Y_MM = 5;
export const PAGE_HEADER_HEIGHT_MM = 25;

export const PAGE_HEADER_HEIGHT_PX = 80;
export const PAGE_CONTENT_HEIGHT =
    A4_HEIGHT - PADDING * 2 - PAGE_HEADER_HEIGHT_PX;

export const PRINT_STYLES = `
    /* CSS Reset */
    *, *::before, *::after {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    h1, h2, h3, h4, h5, h6 {
        font-size: inherit;
        font-weight: inherit;
        margin: 0;
    }

    body {
        line-height: 1.5;
        font-family: "Open Sans", sans-serif;
        -webkit-font-smoothing: antialiased;
    }

    img, picture, video, canvas, svg {
        display: inline;
        max-width: 100%;
    }
    /* Preview */
    .page {
        width: ${PAGE_WIDTH_MM}mm;
        min-height: ${PAGE_HEIGHT_MM}mm;
        padding: ${PADDING_Y_MM}mm ${PADDING_X_MM}mm;
    }
    .image-component {
        display: inline-flex;
    }
    [data-remove-border-on-print="true"] {
        border: none !important;
    }
`;
